import { z } from 'zod'

/**
 * Validation for the Create / Edit role form's text fields.
 *
 * The permission tree (module / feature `has_access` selection) is managed as
 * component state, not RHF — it's a selection map, not text input. The form's
 * submit handler validates that at least one feature is selected separately.
 */
export const roleFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, 'Role name is required')
    .max(100, 'Role name must be 100 characters or fewer'),
  description: z
    .string()
    .trim()
    .max(500, 'Description must be 500 characters or fewer')
    .optional()
    .or(z.literal('')),
})

export type RoleFormValues = z.infer<typeof roleFormSchema>
